// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import organizationFields from '../../fields/organizationFields';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.legalInfos
 * @returns {JSX} RenderCompanyLongName
 */
function RenderCompanyLongName({ legalInfos }) {

    if (!legalInfos) {
        return null;
    }

    return (
        <div className='details-grid-row'>
            <div>
                <Entity
                    entity={organizationFields.LEGAL_INFOS.COMPANY_LONG_NAME.entity}
                    namespace={nsOrganization}
                    className='text-labelGray-foreground'
                />
            </div>
            <div className='font-bold'>
                {
                    legalInfos[organizationFields.LEGAL_INFOS.COMPANY_LONG_NAME.key]
                    || legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L1.key]
                }
                {
                    legalInfos[organizationFields.LEGAL_INFOS.ACRONYM.key] ?
                        <span>(<abbr
                            title={
                                legalInfos[organizationFields.LEGAL_INFOS.COMPANY_LONG_NAME.key]
                                || legalInfos[organizationFields.LEGAL_INFOS.NORMALIZED_ADDRESS_L1.key]
                            }
                        >{legalInfos[organizationFields.LEGAL_INFOS.ACRONYM.key]}</abbr>)</span>
                        : false
                }
            </div>
        </div>
    );
}

RenderCompanyLongName.propTypes = {
    legalInfos: PropTypes.object
};

export default RenderCompanyLongName;